<template>
  <div id="app" class="app_div">
    <!--    上海院LOGO-->
    <!--    <el-image class="login_logo_img" :src="require('@/assets/images/logo_shanghaiyuan.png')"></el-image>-->
    <div class="title_div">
      <el-image
        :src="require('../assets/images/iems/iems_logo.png')"
      ></el-image>
      <div class="title">
        <span>{{ sysName }}</span>
        <div class="title_bag"></div>
      </div>
    </div>
    <div class="login_div">
      <el-form
        :model="loginForm"
        ref="loginForm"
        hide-required-asterisk
        @keyup.enter.native="submitForm('loginForm')"
      >
        <table cellspacing="0">
          <tr class="tr_th">
            <th class="txt_center">欢迎登录</th>
          </tr>
          <tr class="tr_input">
            <td>
              <div class="input_text_div">
                <input
                  type="text"
                  placeholder="请输入用户名"
                  v-model="loginForm.account"
                  maxlength="20"
                  autocomplete
                />
                <span class="icon_span"
                  ><img
                    src="../assets/images/iems/icon_login_account.png"
                    alt=""
                /></span>
                <span class="ver_span"></span>
              </div>
            </td>
          </tr>
          <tr class="tr_info">
            <td>
              <span>{{ info.accountInfo }}</span>
            </td>
          </tr>
          <tr class="tr_input">
            <td>
              <div class="input_text_div">
                <input
                  type="password"
                  placeholder="请输入密码"
                  v-model="loginForm.passwords"
                  maxlength="20"
                  autocomplete
                />
                <span class="icon_span"
                  ><img src="../assets/images/iems/icon_login_pass.png" alt=""
                /></span>
                <span class="ver_span"></span>
              </div>
            </td>
          </tr>
          <tr class="tr_info">
            <td>
              <span>{{ info.passwordInfo }}</span>
            </td>
          </tr>
          <tr class="tr_input">
            <td>
              <div class="input_text_div">
                <input
                  type="text"
                  placeholder="请输入验证码"
                  v-model="loginForm.code"
                  maxlength="4"
                  autocomplete
                />
                <span class="icon_span"
                  ><img src="../assets/images/iems/icon_login_code.png" alt=""
                /></span>
                <span class="ver_span"></span>
                <span class="code_span" @click="getCaptcha"
                  ><el-image class="code_img" :src="captcha"></el-image
                ></span>
              </div>
            </td>
          </tr>
          <tr class="tr_info">
            <td>
              <span>{{ info.captchaInfo }}</span>
            </td>
          </tr>
          <tr>
            <td class="txt_center">
              <el-button
                class="login_button"
                type="primary"
                @click="submitForm('loginForm')"
                >登 录</el-button
              >
            </td>
          </tr>
        </table>
      </el-form>
    </div>
  </div>
</template>

<script>
import myConst from "../util/my-const";
import myApi from "../util/my-api";
import fun from "../util/util";
import store from "../store";
import md5 from "md5";
import { mapState, mapActions } from "vuex";
export default {
  name: "login",
  data() {
    return {
      sysName: "",
      loginForm: {
        account: "",
        passwords: "",
        uuid: "",
        code: "",
        logged: myConst.logged.default,
        token: this.$store.getters.getToken,
        hostId: "", //登录主机
        hostIp: "", //登录ip
        browserName: "", //浏览器名称
        browserVersion: "", //浏览器版本
      },
      info: {
        accountInfo: "",
        passwordInfo: "",
        captchaInfo: "",
      },
      captcha: null,
      code: "", //返回验证码
      path: "", //home页路由
    };
  },
  mounted() {
    this.getCaptcha();
    this.loadSysName();
    this.getIp();
    if (!fun.isNull(this.$store.getters.getToken)) {
      if (
        !fun.isNull(this.$store.getters.getRouterList) &&
        this.$store.getters.getRouterList.length > 0
      ) {
        this.$router.push({
          path: this.$store.getters.getRouterList[0].homePath,
        });
      }
    }
  },
  methods: {
    ...mapActions("button", ["getPerButton"]),
    ...mapActions("integSysMenu", ["getPerStationList"]),
    //加载系统名称
    loadSysName() {
      let _this = this;
      this.$axios
        .get(myApi.dictGetSysName)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            _this.sysName = res.data.data;
          }
        })
        .catch(() => {});
    },
    //提交信息登录
    submitForm(formName) {
      let _this = this;
      this.loginForm.hostId = "";
      this.loginForm.browserName = this.getBrowser().type; //浏览器名称
      this.loginForm.browserVersion = this.getBrowser().versions; //浏览器版本
      if (!_this.verInputData(_this)) {
        return false;
      }
      this.$axios
        .post(myApi.loginPc, _this.loginForm)
        .then((res) => {
          //判断是否登录成功
          if (res.data.code === myConst.code.success) {
            //登录成功保存token
            _this.$store.commit("setToken", res.data.data.token);
            //登录成功获取路由表
            this.loadRouter().then(() => {
              _this.$router.push({ path: this.path });
            });

            // 登录成功获取权限按钮
            this.getPerButton();
            //登录成功获取权限电站列表
            this.getPerStationList();
          } else {
            this.getCaptcha();
            return false;
          }
        })
        .catch(() => {
          this.getCaptcha();
        });
    },

    //获取路由表
    loadRouter() {
      return new Promise((resolve, reject) => {
        this.$axios.get(myApi.getRouteHomeByPermission).then((res) => {
          if (res.data.code === myConst.code.success) {
            if (res.data.data.length > 0) {
              this.$store.commit("setRouterList", res.data.data); //将返回的路由存储到vuex
              let myRouter = this.$store.getters.getRouterList;
              this.path = myRouter[0].homePath; //默认进入第一个系统,获取第一个系统的路由路径
              resolve();
            }
          } else {
            // reject()
          }
        });
      });
    },

    //输入信息校验
    verInputData(_this) {
      let bol = true;
      if (fun.isNull(_this.loginForm.account)) {
        _this.info.accountInfo = "请输入账号";
        bol = false;
      } else {
        _this.info.accountInfo = "";
      }

      if (fun.isNull(_this.loginForm.passwords)) {
        _this.info.passwordInfo = "请输入密码";
        bol = false;
      } else {
        _this.info.passwordInfo = "";
      }

      if (fun.isNull(_this.loginForm.code)) {
        _this.info.captchaInfo = "请输入验证码";
        bol = false;
      } else if (_this.loginForm.code.trim().length != 4) {
        _this.info.captchaInfo = "请检查输入验证码长度";
        bol = false;
      } else if (_this.loginForm.code.trim() != _this.code) {
        _this.info.captchaInfo = "输入验证码错误";
        bol = false;
      } else {
        _this.info.captchaInfo = "";
      }
      return bol;
    },

    //请求验证码
    getCaptcha() {
      let _this = this;
      this.$axios.get(myApi.captcha).then((res) => {
        //请求验证码
        _this.loginForm.uuid = res.data.data.uuid;
        _this.code = res.data.data.code;
        _this.captcha = res.data.data.captcha;
        _this.loginForm.code = "";
      });
    },

    //获取浏览器信息
    getBrowser() {
      var UserAgent = navigator.userAgent.toLowerCase();
      var browserInfo = {};
      var browserArray = {
        IE: /msie|trident/.test(UserAgent),
        Edge: /edg/.test(UserAgent),
        Chrome:
          /chrome/.test(UserAgent) &&
          !/edg/.test(UserAgent) &&
          !/opr/.test(UserAgent),
        Firefox: /firefox/.test(UserAgent),
        Opera: /opera/.test(UserAgent) || /opr/.test(UserAgent),
        Safari:
          /safari/.test(UserAgent) &&
          !/chrome/.test(UserAgent) &&
          !/opr/.test(UserAgent),
        QQBrowser: /qqbrowser/.test(UserAgent),
        WeixinBrowser: /micromessenger/.test(UserAgent),
      };

      for (var i in browserArray) {
        if (browserArray[i]) {
          var versions = "";
          var versionMatch =
            UserAgent.match(/(?:version|(?:\s))([\d.]+)(?=\/|$)/) ||
            UserAgent.match(new RegExp(i.toLowerCase() + "/([\\d.]+)", "i"));
          versions = versionMatch ? versionMatch[1] : "unknown";
          browserInfo.type = i;
          browserInfo.versions = parseFloat(versions);
          break;
        }
      }

      return browserInfo;
    },

    //获取登录主机的ip信息
    getIp() {
      const data = {
        key: "4FYBZ-4FV3A-ZCOK6-CUDCS-CW5OJ-BHB4S",
      };
      const url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
      data.output = "jsonp";
      this.$jsonp(url, data)
        .then((res) => {
          this.loginForm.hostIp =
            res.result.ad_info.province + res.result.ad_info.city;
        })
        .catch(() => {
          this.loginForm.hostIp = "";
        });
    },
  },
  created() {
    // this.$store.commit("logoutClear"); //缓存数据清除
    // this.$store.commit("integSysMenu/clearMenu") //清除综合系统菜单相关数据
    // this.$store.commit('statMenu/clearStatMent') //清除电站菜单相关数据
    // this.$store.commit('enerStorSysMenu/clearEneryMenu') //清除储能系统菜单相关数据
    // this.$store.commit('photovoltaicSysMenu/clearPhotovoMenu') //清除光伏系统菜单相关数据
  },
};
</script>

<style src="../assets/css/login.css" scoped>
</style>
/*@import "../assets/css/login.css";*/  //此书写方法会影响其他文件
